import {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import raiseFlashMessage from '@/utils/raiseFlashMessage';
import {TOAST_PARAM_KEY} from '@/config/constants';

function useToastFromUrl() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const toastMessage = searchParams.get(TOAST_PARAM_KEY);
    if (!toastMessage) {
      return;
    }

    // Raise the toast
    raiseFlashMessage({status: 'success', message: toastMessage});

    // Remove the toast param from the URL to avoid duplicate toasts
    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete(TOAST_PARAM_KEY);
    setSearchParams(nextParams, {replace: true});
  }, [searchParams, setSearchParams]);
}

export default useToastFromUrl;
